module.exports = __webpack_public_path__ + "img/undraw_data_processing_yrrv.e34eda67.svg";